import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  REPORTS_EXPORT_OOS_ACCOUNT_CUSTOMER_BEGIN,
  REPORTS_EXPORT_OOS_ACCOUNT_CUSTOMER_SUCCESS,
  REPORTS_EXPORT_OOS_ACCOUNT_CUSTOMER_FAILURE,
  REPORTS_EXPORT_OOS_ACCOUNT_CUSTOMER_DISMISS_ERROR,
} from './constants';
import { EXPORT_API_REQUEST_URL } from '../../../common/apiConfig';
export function exportOosAccountCustomer(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_EXPORT_OOS_ACCOUNT_CUSTOMER_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      if(args.sortedBy === undefined || args.sortedBy === null) {
        args = {
          ...args,
          sort: "ascend",
          sortedBy: "site",
        }
      }
      const doRequest = axios.post(`${EXPORT_API_REQUEST_URL}/oosAccount/exportCustomerReport`, args);
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_EXPORT_OOS_ACCOUNT_CUSTOMER_SUCCESS,
            data: res.data.data,
          });
          resolve(res.data.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_EXPORT_OOS_ACCOUNT_CUSTOMER_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportOosAccountCustomerError() {
  return {
    type: REPORTS_EXPORT_OOS_ACCOUNT_CUSTOMER_DISMISS_ERROR,
  };
}

export function useExportOosAccountCustomer() {
  const dispatch = useDispatch();

  const { exportOosAccountCustomerPending, exportOosAccountCustomerError } = useSelector(
    state => ({
      exportOosAccountCustomerPending: state.reports.exportOosAccountCustomerPending,
      exportOosAccountCustomerError: state.reports.exportOosAccountCustomerError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportOosAccountCustomer(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportOosAccountCustomerError());
  }, [dispatch]);

  return {
    exportOosAccountCustomer: boundAction,
    exportOosAccountCustomerPending,
    exportOosAccountCustomerError,
    dismissExportOosAccountCustomerError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_EXPORT_OOS_ACCOUNT_CUSTOMER_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportOosAccountCustomerPending: true,
        exportOosAccountCustomerError: null,
      };

    case REPORTS_EXPORT_OOS_ACCOUNT_CUSTOMER_SUCCESS:
      // The request is success
      return {
        ...state,
        exportOosAccountCustomerPending: false,
        exportOosAccountCustomerError: null,
      };

    case REPORTS_EXPORT_OOS_ACCOUNT_CUSTOMER_FAILURE:
      // The request is failed
      return {
        ...state,
        exportOosAccountCustomerPending: false,
        exportOosAccountCustomerError: action.data.error,
      };

    case REPORTS_EXPORT_OOS_ACCOUNT_CUSTOMER_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportOosAccountCustomerError: null,
      };

    default:
      return state;
  }
}
